import { registerWidget, DME } from "dmeditor";
import { Favourite, FavouriteDefinition } from "./Favourite";

export default () => {
  registerWidget(FavouriteDefinition, {
    render: Favourite,
  });
};
